module.exports = __webpack_public_path__ + "omniv2/img/icon-pin-inverted.0ea906d0.svg";